import React, { useState, useEffect, useContext } from 'react';
import { RootStoreContext } from '../stores/RootStore';
import { ISelect } from '../models/General';
import { ProgramGenerateParam, ProgramGenerateList, GenerateSPParam, GenerateLogList, GenerateLogParam } from '../models/StudyEvaluation';
import Select from "react-select";
import Alert from '../utils/Alert';
import { Redirect } from 'react-router-dom';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';


const GeneratePage = () => {

    const rootStore = useContext(RootStoreContext);
    const { getInstitution, getCareer, getSemesterCheckUas } = rootStore.commonStore;
    const { getProgramGenerateList, generateSP, generateLog } = rootStore.studyEvaluationStore;
    const emplidVal = window.localStorage.getItem('emplid');

    const [list, setList] = useState<ProgramGenerateList[]>([])
    const [listLog, setListLog] = useState<GenerateLogList[]>([])
    const [institution, setInstitution] = useState<ISelect[]>();
    const [institutionVal, setInstitutionVal] = useState<string>('');
    const [career, setCareer] = useState<ISelect[]>();
    const [careerVal, setCareerVal] = useState<string>('');
    const [semesterCode, setSemesterCode] = useState<string>('');
    const [semesterDesc, setSemesterDesc] = useState<string>('');

    const [semester, setSemester] = useState<ISelect[]>();
    const [semesterVal, setSemesterVal] = useState<string>('');
    const [semesterShownVal, setSemesterShownVal] = useState<ISelect>(); // untuk value yang ditampilkan di user

    const [statusAlert, setStatusAlert] = useState(0)
    const [status, setStatus] = useState("")
    const [message, setMessage] = useState("")
    const [redirect, setRedirect] = useState(false)
    const [btnGenerate, setBtnGenerate] = useState(false)

    const [isLoading, setIsLoading] = useState(false);

    function handleInstitutionSelect(event: any) {
        setInstitutionVal(event.value);

        const careerData = getCareer(String(emplidVal), event.value);
        careerData.then(function (result) {
            setCareer(result);
        })
    };

    function handleCareerSelect(event: any) {

        setCareerVal(event.value);

        getSemesterData(institutionVal, event.value)

    };

    function handleSemesterSelect (event: any) {
        setSemesterVal(event.value)
        setSemesterShownVal(event)

        setSemesterCode(event.value)
        setSemesterDesc(event.label)

        if(event.value!=""){
            
        }
    };

    const getSemesterData = (institution:string, career:string)=> {
        const semesterData = getSemesterCheckUas(institution, career);
        semesterData.then(function(result) {
            //limit semester select
            result.length = 2 
            setSemester(result);

        })
    }

    const save = (program: string) => {

        setBtnGenerate(true);

        const param: GenerateSPParam = {
            INSTITUTION: String(institutionVal),
            SEMESTER: String(semesterCode),
            ACAD_PROGRAM: program,
            STATUS: 1,
            CREATED_BY: String(emplidVal)
        };

        generateSP(param).then(function (response) {
            setMessage(response.message)
            setStatus(response.status)
            setStatusAlert(1)
            loadData()
            setBtnGenerate(false)
        })
    }

    const log = (program: string) => {
        const paramLog: GenerateLogParam = {
            INSTITUTION: String(institutionVal),
            SEMESTER: String(semesterCode),
            ACAD_PROGRAM: program
        };

        generateLog(paramLog).then(function (response) {
            if (response.length === 0) {
                setMessage("Log does not exit")
                setStatus("201")
                setStatusAlert(1)
            }
            else {
                setListLog(response)
                setRedirect(true)
            }
        })
    }

    const renderProgramList = () => {
        return list.map((item, index) => {
            return (
                <React.Fragment key={item.CODE}>
                    <tr key={item.CODE}>
                        <td>{index + 1}</td>
                        <td>{item.CODE}</td>
                        <td>{item.DESCR}</td>
                        <td>{item.LATESTGENERATED}</td>
                        <td>
                            <button
                                className="btn btn-warning"
                                onClick={async () => { await log(item.CODE) }}>
                                Log
                            </button>
                            &nbsp;&nbsp;&nbsp;
                            <button
                                disabled={btnGenerate}
                                className={item.BUTTONCOLOR}
                                onClick={async () => { await save(item.CODE) }}>
                                {item.BUTTONDESC}
                            </button>
                        </td>
                    </tr>
                </React.Fragment>
            );
        })
    }

    const param: ProgramGenerateParam = {
        INSTITUTION: String(institutionVal),
        SEMESTER: String(semesterCode),
        CAREER: String(careerVal),
        EMPLID: String(emplidVal)
    };

    useEffect(() => {

        const institutionData = getInstitution(String(emplidVal));
        institutionData.then(function (result) {
            setInstitution(result);
        })

        loadData()

    }, [institutionVal, careerVal, message, status, semesterCode, semesterDesc, btnGenerate])

    function loadData() {
        if (semesterCode != "") {
            setIsLoading(true);
            getProgramGenerateList(param).then(function (response) {
                setList(response)
                setIsLoading(false);
            })
        }
    }

    return (
        <React.Fragment>
            {isLoading
                ? <CircleSpinnerOverlay zIndex={2000} loading={isLoading} color="#00FFFF" />
                : <></>
            }
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Generate Study Evaluation</h1>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Institution</label>
                                                <Select
                                                    name="institution"
                                                    placeholder="Choose Institution"
                                                    options={institution}
                                                    onChange={handleInstitutionSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Career</label>
                                                <Select
                                                    name="career"
                                                    placeholder="Choose Career"
                                                    options={career}
                                                    onChange={handleCareerSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Semester</label>
                                                <Select
                                                    name="semester"
                                                    placeholder="Choose Semester"
                                                    options={semester}
                                                    onChange={handleSemesterSelect}
                                                    value={semesterShownVal}
                                                />
                                            </div>
                                        </div>

                                        {/* <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Latest Semester</label>
                                                <input disabled={true} type="text" required className="form-control" value={semesterDesc} />
                                            </div>
                                        </div> */}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Program List</h3>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            {
                                                statusAlert != 0 ?
                                                    <> <Alert message={message} status={status} /> </> : <> </>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Code</th>
                                                            <th>Program</th>
                                                            <th>Latest Generated</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {renderProgramList()}
                                                    </tbody>
                                                </table>
                                                {list.length == 0 ? <div style={{ textAlign: 'center', marginTop: '2%' }}>No Data</div> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {
                redirect ?
                    <>
                        return <Redirect push
                            to={{
                                pathname: "/log",
                                state: {
                                    data: listLog
                                }
                            }}
                        />
                    </> : <></>
            }
        </React.Fragment>
    );
}

export default GeneratePage;